import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatatableComponent } from './datatable/datatable.component';
import { MapComponent } from './map/map.component';
import { PlateNumberComponent } from './plate-number/plate-number.component';
import { StatusComponent } from './status/status.component';
import { HeaderComponent } from './header/header.component';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from './navbar/navbar.component';
import { ServiceIconsComponent } from './service-icons/service-icons.component';
import { StepperComponent } from './stepper/stepper.component';
import { BillingSummaryComponent } from './billing-summary/billing-summary.component';
import { HttpClientModule } from '@angular/common/http';
import { HomeService } from '../pages/home/services/home.service';
import { LogoutComponent } from './logout/logout.component';
import { ToggleComponent } from './toggle/toggle/toggle.component';
import { TranslateModule } from '@ngx-translate/core';
import { SpinnerDatatableComponent } from './spinner-datatable/spinner-datatable.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InfoModalComponent } from './info-modal/info-modal.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { GanttComponent } from './gantt/gantt.component';
import { CancelModalComponent } from './datatable/components/cancel-modal/cancel-modal.component';
import { VehicleStatusComponent } from './vehicle-status/vehicle-status.component';
import { AlertComponent } from './alert/alert.component';
import { AddressBoxComponent } from './billing-summary/components/address-box/address-box.component';
import { AdditionalInfoComponent } from './billing-summary/components/additional-info/additional-info.component';
import { CommentsComponent } from './billing-summary/components/comments/comments.component';
import { PricingSummaryComponent } from './billing-summary/components/pricing-summary/pricing-summary.component';
import { CancellationPolicyComponent } from './billing-summary/components/cancellation-policy/cancellation-policy.component';
import { CheckoutContainerComponent } from './billing-summary/components/checkout-container/checkout-container.component';
import { ModalPromotionCodeComponent } from './billing-summary/modals/modal-promotion-code/modal-promotion-code.component';
import { ModalCancellationPolicyComponent } from './billing-summary/modals/modal-cancellation-policy/modal-cancellation-policy.component';
import { ModalRefuelingFeeComponent } from './billing-summary/modals/modal-refueling-fee/modal-refueling-fee.component';
import { ModalMinimumConditionsComponent } from './billing-summary/modals/modal-minimum-conditions/modal-minimum-conditions.component';
import { ContactInfoComponent } from './billing-summary/components/contact-info/contact-info.component';
import { ConfirmDialogComponent } from './confirm-modal/confirm-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FunnelDialogComponent } from './funnel-dialog/funnel-dialog.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ExtrasFunnelDialogComponent } from './funnel-dialog/extras-funnel-dialog/extras-funnel-dialog.component';
import { SummaryFunnelDialogComponent } from './funnel-dialog/summary-funnel-dialog/summary-funnel-dialog.component';
import { ModalTyreFullInfoComponent } from './billing-summary/modals/modal-tyre-full-info/modal-tyre-full-info.component';
import { TopbarComponent } from './topbar/topbar.component';
import { SupportModalComponent } from './support-modal/support-modal.component';
import { TagManagerComponent } from './tag-manager/tag-manager.component';
import { ReusableTableComponent } from './reusable-table/reusable-table.component';
import { CustomSnackbarComponent } from './snackbar/snackbar.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PlacesAutocompleteComponent } from './places-autocomplete/places-autocomplete.component';
import { PhoneInputComponent } from './phone-input/phone-input.component';
import { HasRoleDirective } from '../core/directives/has-role.directive';
import { CurrencyPipesModule } from '../core/pipes/pipes.module';
import { CurrencyDirectivesModule } from '../core/directives/directives.module';
import { ReusableSearcherComponent } from './reusable-searcher/reusable-searcher.component';
import { HorizontalStepperComponent } from './horizontal-stepper/horizontal-stepper.component';
import { ConfirmMessageComponent } from './confirm-message-modal/confirm-message.component';
import { WheelCharacteristicsInputComponent } from './wheel-characteristics-input/wheel-characteristics-input.component';
import { SelectByKeysDropdownComponent } from './select-by-keys-dropdown/select-by-keys-dropdown.component';
import { DateInputComponent } from './date-input/date-input.component';
import { DateRangeInputComponent } from './date-range-input/date-range-input.component';
import { DirectionGoogleMapInputComponent } from './direction-google-map-input/direction-google-map-input.component';
import { MoreOptionsTableRowComponent } from './more-options-table-row/more-options-table-row.component';
import { TablePaginatorComponent } from './table-paginator/table-paginator.component';
import { MileageCounterComponent } from './mileage-counter/mileage-counter.component';
import { SearchCreateDropdownComponent } from './search-create-dropdown/search-create-dropdown.component';
import { AgendaConfirmationModalComponent } from './confirm-modal/agenda-confirmation-modal.component';
import { EditButtonComponent } from './edit-button/edit-button.component';
import { MarketplacePopUpComponent } from './marketplace-pop-up/marketplace-pop-up.component';
import { AppDropdownComponent } from './dropdown/dropdown.component';
import { SeasonIconComponent } from './season-icon/season-icon.component';
import { StockTableComponent } from '../pages/stock/components/stock-table/stock-table.component';
import { ExportStockDrawerComponent } from './export-stock-drawer/export-stock-drawer.component';
import { StockAlertChipsComponent } from './components/stock-alert-chips/stock-alert-chips.component';
import { OrdersService } from '../pages/orders/services/orders.service';
import { TireBrandDropdownComponent } from './tyre-brand-dropdown/tire-brand-dropdown.component';
import { PlateScannerComponent } from './plate-scanner/plate-scanner.component';
import { TireScannerComponent } from './tire-scanner/tire-scanner.component';
import { PhoneNumberInputComponent } from './phone-number-input/phone-number-input.component';
import { NotificationBellComponent } from './notification-bell/notification-bell.component';
import { NotificationDetailModalComponent } from './notification-bell/notification-detail-modal/notification-detail-modal.component';
import { NotificationActionsButtonsComponent } from './notification-bell/notification-actions-buttons/notification-actions-buttons.component';
import { CreateTaskModalComponent } from '../pages/my-tasks/components/create-task-modal/create-task-modal.component';
import { CalendarDayViewComponent } from './calendar-day-view/calendar-day-view.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { TimeUntilPipe } from './pipes/time-until.pipe';
import { LocalizedDatePipe } from './pipes/localized-date.pipe';
import { DisplayOrDashPipe } from './pipes/display-or-dash.pipe';
import { GradeLetterPipe } from './pipes/grade-letter.pipe';
import { NotificationFilterBarComponent } from './notification-filter-bar/notification-filter-bar.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FilterPlaceholderDropdownComponent } from './filter-placeholder-dropdown/filter-placeholder-dropdown.component';
import { DropdownSelectComponent } from './dropdown-select/dropdown-select.component';
import { BulkUploadStatusIndicatorComponent } from './bulk-upload-status-indicator/bulk-upload-status-indicator.component';

@NgModule({
  declarations: [
    DatatableComponent,
    HeaderComponent,
    MapComponent,
    NavbarComponent,
    PlateNumberComponent,
    StatusComponent,
    ServiceIconsComponent,
    StepperComponent,
    BillingSummaryComponent,
    LogoutComponent,
    ToggleComponent,
    SpinnerDatatableComponent,
    InfoModalComponent,
    FunnelDialogComponent,
    GanttComponent,
    CancelModalComponent,
    VehicleStatusComponent,
    AlertComponent,
    AddressBoxComponent,
    AdditionalInfoComponent,
    CommentsComponent,
    PricingSummaryComponent,
    CancellationPolicyComponent,
    CheckoutContainerComponent,
    ModalMinimumConditionsComponent,
    ModalPromotionCodeComponent,
    ModalCancellationPolicyComponent,
    ModalRefuelingFeeComponent,
    ContactInfoComponent,
    ConfirmDialogComponent,
    ExtrasFunnelDialogComponent,
    SummaryFunnelDialogComponent,
    ModalTyreFullInfoComponent,
    TopbarComponent,
    SupportModalComponent,
    TagManagerComponent,
    ReusableTableComponent,
    CustomSnackbarComponent,
    PlacesAutocompleteComponent,
    PhoneInputComponent,
    HasRoleDirective,
    ReusableSearcherComponent,
    HorizontalStepperComponent,
    ConfirmMessageComponent,
    WheelCharacteristicsInputComponent,
    SelectByKeysDropdownComponent,
    DateInputComponent,
    DateRangeInputComponent,
    DirectionGoogleMapInputComponent,
    MoreOptionsTableRowComponent,
    TablePaginatorComponent,
    MileageCounterComponent,
    SearchCreateDropdownComponent,
    AgendaConfirmationModalComponent,
    EditButtonComponent,
    MarketplacePopUpComponent,
    AppDropdownComponent,
    SeasonIconComponent,
    StockTableComponent,
    ExportStockDrawerComponent,
    TireBrandDropdownComponent,
    PlateScannerComponent,
    TireScannerComponent,
    PhoneNumberInputComponent,
    NotificationBellComponent,
    NotificationDetailModalComponent,
    NotificationActionsButtonsComponent,
    CreateTaskModalComponent,
    CalendarDayViewComponent,
    TimeUntilPipe,
    LocalizedDatePipe,
    DisplayOrDashPipe,
    GradeLetterPipe,
    NotificationFilterBarComponent,
    FilterPlaceholderDropdownComponent,
    DropdownSelectComponent,
    BulkUploadStatusIndicatorComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule,
    HttpClientModule,
    TranslateModule.forChild(),
    ModalModule.forRoot(),
    MatDialogModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatMenuModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    StockAlertChipsComponent,
    FullCalendarModule,
    MatAutocompleteModule,
    CurrencyPipesModule,
    CurrencyDirectivesModule,
  ],
  exports: [
    RouterModule,
    ReusableTableComponent,
    DatatableComponent,
    HeaderComponent,
    MapComponent,
    NavbarComponent,
    PlateNumberComponent,
    StatusComponent,
    ServiceIconsComponent,
    StepperComponent,
    BillingSummaryComponent,
    ToggleComponent,
    SpinnerDatatableComponent,
    GanttComponent,
    VehicleStatusComponent,
    AlertComponent,
    ConfirmDialogComponent,
    TopbarComponent,
    TagManagerComponent,
    TranslateModule,
    CustomSnackbarComponent,
    MatSnackBarModule,
    MatMenuModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatTooltipModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    PlacesAutocompleteComponent,
    PhoneInputComponent,
    ReusableSearcherComponent,
    HasRoleDirective,
    HorizontalStepperComponent,
    ConfirmMessageComponent,
    WheelCharacteristicsInputComponent,
    SelectByKeysDropdownComponent,
    DateInputComponent,
    DateRangeInputComponent,
    DirectionGoogleMapInputComponent,
    MoreOptionsTableRowComponent,
    TablePaginatorComponent,
    MileageCounterComponent,
    SearchCreateDropdownComponent,
    AgendaConfirmationModalComponent,
    EditButtonComponent,
    MarketplacePopUpComponent,
    AppDropdownComponent,
    SeasonIconComponent,
    StockTableComponent,
    StockAlertChipsComponent,
    FormsModule,
    TireBrandDropdownComponent,
    PlateScannerComponent,
    TireScannerComponent,
    PhoneNumberInputComponent,
    NotificationBellComponent,
    NotificationDetailModalComponent,
    CalendarDayViewComponent,
    TimeUntilPipe,
    LocalizedDatePipe,
    DisplayOrDashPipe,
    GradeLetterPipe,
    NotificationFilterBarComponent,
    FilterPlaceholderDropdownComponent,
    DropdownSelectComponent,
    BulkUploadStatusIndicatorComponent,
    CurrencyPipesModule,
    CurrencyDirectivesModule
  ],
  providers: [HomeService, OrdersService],
})
export class SharedModule { }
